import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { auth } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  // Derive impersonation state from localStorage (persists across navigations)
  const [isImpersonating, setIsImpersonating] = useState(
    () => !!localStorage.getItem('isImpersonating')
  );

  // Restore session on mount
  useEffect(() => {
    const token = localStorage.getItem('wholesaleToken');
    if (!token) { setLoading(false); return; }
    auth.me()
      .then(res => setUser(res.data))
      .catch(() => localStorage.removeItem('wholesaleToken'))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await auth.login({ email, password });
    const { token, user: userData } = res.data;
    localStorage.setItem('wholesaleToken', token);
    setUser(userData);
    return userData;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('wholesaleToken');
    localStorage.removeItem('wholesaleAdminToken');
    localStorage.removeItem('isImpersonating');
    setUser(null);
    setIsImpersonating(false);
  }, []);

  // Restore the saved admin session after impersonation ends.
  // Swaps tokens back and does a hard redirect to force AuthContext re-init.
  const restoreAdminSession = useCallback(() => {
    const adminToken = localStorage.getItem('wholesaleAdminToken');
    if (!adminToken) return;
    localStorage.setItem('wholesaleToken', adminToken);
    localStorage.removeItem('wholesaleAdminToken');
    localStorage.removeItem('isImpersonating');
    setIsImpersonating(false);
    window.location.href = '/admin/customers';
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isImpersonating, restoreAdminSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export default AuthContext;
